<breadcrumb [paginas]="[
  {route:'/home',name:'Home'},
  {route:'/plano-melhoria/correcao-vinculo',name:'Correção de vínculo PMCE'}
]" />

<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Correção de vínculo PMCE</h2>
    <p class="descricao-page">
      Incidente URE Jundiaí — planos 5059 (José de Anchieta) e 3341 (Antonio Dutra).
      Utilize o botão Ajustar para informar o CIE da escola correta.
    </p>
  </div>
</section>

<section class="conteudo-principal">
  <div class="container-conviva form-registro container-grid">
    <app-tabulator-table
      [columnNames]="colunasGrid"
      [tipoRelatorio]="2"
      [tableData]="divergencias"
      [mostrarFiltro]="false"
      [mostrarImprimir]="false"
      [mostrarExportarHtml]="false"
      [mostrarExportarExcel]="true"
      [mostrarExportarPDF]="false"
      [orientacaoPortrait]="false">
    </app-tabulator-table>
  </div>
</section>

<app-modal *ngIf="showModalAjustar">
  <div class="container-conviva form-registro modal-envolvidos">
    <h3 style="margin-bottom: 1rem;">Ajustar vínculo - Plano {{ divergenciaSelecionada?.codigoPlanoMelhoria }}</h3>

    <p><b>Escola de origem (correta):</b> {{ formatarEscola(divergenciaSelecionada?.codigoEscolaOrigem, divergenciaSelecionada?.nomeEscolaOrigem) }}</p>
    <p><b>Escola atual (incorreta):</b> {{ formatarEscola(divergenciaSelecionada?.codigoEscolaAtual, divergenciaSelecionada?.nomeEscolaAtual) }}</p>

    <form [formGroup]="formAjuste" style="margin-top: 1.5rem;">
      <div class="grupo-filter-full">
        <label for="codigoEscolaDestino">CIE da escola</label>
        <input
          type="number"
          id="codigoEscolaDestino"
          class="input-date"
          formControlName="codigoEscolaDestino"
          placeholder="Informe o código CIE da escola" />
      </div>
    </form>

    <div class="container-btns" style="justify-content: center; gap: 15px; margin-top: 20px;">
      <button type="button" class="btn_primary" (click)="confirmarAjuste()">Ajustar</button>
      <button type="button" class="btn_outline" (click)="fecharModalAjustar()">Cancelar</button>
    </div>
  </div>
</app-modal>
